import React, { useEffect, useState, useCallback, useMemo } from 'react';
import {useParams, useLocation, useNavigate} from 'react-router-dom';
import {
    Container,
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    Alert,
    Input,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Spinner,
    UncontrolledTooltip,
    FormGroup,
    Label,
    ModalFooter
} from 'reactstrap';
import CountUp from 'react-countup';
import axios from 'axios';
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/flatpickr.min.css';
import TableContainer from '../../../Components/Common/TableContainer';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import DeleteModal from '../../../Components/Common/DeleteModal';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useTranslation } from 'react-i18next';
import api,{handleApiError} from '../../../helpers/api';
import {useDispatch} from "react-redux";


const customStyles = `
  .inscriptions-card {
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
  .inscriptions-modal .modal-content {
    border-radius: 8px;
    border: none;
  }
  .inscriptions-modal .modal-header {
    background: linear-gradient(135deg, #2a4966 0%, #0ab39c 100%);
    color: #ffffff;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    padding: 1.5rem;
  }
  .inscriptions-modal .modal-header h5 {
    font-weight: 600;
    font-size: 1.4rem;
    color: #ffffff;
  }
  .inscriptions-modal .modal-body {
    padding: 1.5rem;
    background-color: #f9fafb;
  }
  .inscriptions-modal .form-control, .inscriptions-modal .form-select {
    border-radius: 4px;
    border: 1px solid #ced4da;
    font-size: 0.9rem;
    padding: 0.5rem 1rem;
  }
  .inscriptions-modal .form-control:focus, .inscriptions-modal .form-select:focus {
    border-color: #0ab39c;
    box-shadow: 0 0 0 0.2rem rgba(10, 179, 156, 0.25);
  }
  .inscriptions-modal .form-label {
    font-weight: 500;
    color: #2a4966;
  }
  .inscriptions-modal .form-check-label {
    font-size: 0.9rem;
    color: #2a4966;
  }
  .inscriptions-modal .form-check-input {
    border-color: #ced4da;
  }
  .inscriptions-modal .form-check-input:checked {
    background-color: #0ab39c;
    border-color: #0ab39c;
  }
  .inscriptions-table th, .inscriptions-table td {
    vertical-align: middle;
    padding: 0.75rem;
  }
  .inscriptions-table tr:hover {
    background-color: #f1f5f7;
  }
  .inscriptions-table tr.selected {
    background-color: #e6f7f5;
  }
  .widget-card {
    transition: transform 0.3s ease;
  }
  .widget-card:hover {
    transform: translateY(-5px);
  }
  .filter-container {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    align-items: center;
    flex-wrap: nowrap;
    overflow-x: auto;
    margin-bottom: 1rem;
    padding-bottom: 0.5rem;
  }
  .filter-container .form-control, .filter-container .form-select {
    border-radius: 4px;
    border: 1px solid #ced4da;
    min-width: 150px;
    font-size: 0.9rem;
    padding: 0.5rem 1rem;
  }
  .filter-container .form-control:focus, .filter-container .form-select:focus {
    border-color: #0ab39c;
    box-shadow: 0 0 0 0.2rem rgba(10, 179, 156, 0.25);
  }
  .action-btn {
    font-size: 0.85rem;
    padding: 0.4rem 0.8rem;
    transition: background-color 0.3s ease, transform 0.2s ease;
  }
  .action-btn:hover {
    transform: translateY(-2px);
  }
  .new-badge {
    margin-left: 0.5rem;
    font-size: 0.75rem;
    vertical-align: middle;
  }
  .card-header {
    background-color: transparent;
    border-bottom: 1px solid #e9ecef;
    padding: 1rem 1.5rem;
  }
  .card-title {
    font-size: 1.25rem;
    font-weight: 600;
    color: #2a4966;
  }
  .dropdown-menu {
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    border: none;
  }
  .dropdown-item {
    font-size: 0.85rem;
    padding: 0.5rem 1rem;
    color: #2a4966;
  }
  .dropdown-item:hover {
    background-color: #f1f5f7;
    color: #0ab39c;
  }
  .dropdown-item i {
    margin-right: 0.5rem;
  }
  @media (max-width: 768px) {
    .inscriptions-modal .modal-body {
      padding: 1rem;
    }
    .filter-container {
      flex-wrap: nowrap;
      overflow-x: auto;
    }
    .filter-container .form-control, .filter-container .form-select {
      min-width: 120px;
      font-size: 0.85rem;
    }
  }
`;

const InscriptionsList = () => {
    const { t } = useTranslation();
    document.title = t("inscriptions_list.title");

    const { id } = useParams();
    const location = useLocation();
    const [inscriptions, setInscriptions] = useState([]);
    const [filteredInscriptions, setFilteredInscriptions] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [viewModal, setViewModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [createMeetingModal, setCreateMeetingModal] = useState(false);
    const [selectedInscription, setSelectedInscription] = useState(null);
    const [selectedIds, setSelectedIds] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [sortOrder, setSortOrder] = useState('desc');
    const [filterHasMeeting, setFilterHasMeeting] = useState('all');
    const [dropdownOpen, setDropdownOpen] = useState({});
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [users, setUsers] = useState([]);
    const [meetingForm, setMeetingForm] = useState({
       title: `Meeting Title: `,
        platform: 'Zoom',
        hostEmail: '',
        date: new Date().setHours(new Date().getHours() + 1),
        endDate: new Date(new Date().setMonth(new Date().getMonth() + 1)),
        requireAuthentication: false,
        waitingRoom: false,
        recurrenceType: 'One-Time',
        repeatInterval: 1,
        weeklyDays: '',
        monthlyDay: 1,
        password: '',
        duration: 60,
    });
    const [meetingLoading, setMeetingLoading] = useState(false);

    const fetchInscriptions = useCallback(async () => {
        try {
            setIsLoading(true);
            const response = await api.get(`/formation/${id}/inscriptions`, {
                withCredentials: true,
            });
            setInscriptions(response.data.data);
            setFilteredInscriptions(response.data.data);
            setIsLoading(false);
        } catch (err) {
            if (err.response.data?.status === 401 || err.response.data?.status === 403) {
                await handleApiError(err, dispatch, navigate);
            } else {
                setError(t('inscriptions_list.error_fetch'));
                setIsLoading(false);
                toast.error(t('inscriptions_list.error_fetch_toast'));
            }
        }
    }, [id, t, dispatch, navigate]);
    const fetchUsers = useCallback(async () => {
        try {
            const response = await api.get('/user?role=admin,editor', {
                withCredentials: true,
            });
            setUsers(response.data.users);
        } catch (err) {
            if (err.response.data?.status === 401 || err.response.data?.status === 403) {
                await handleApiError(err, dispatch, navigate);
            } else {
                toast.error(t('inscriptions_list.error_users_toast'));
            }
        }
    }, [t, dispatch, navigate]);
    useEffect(() => {
        fetchInscriptions();
        fetchUsers();
    }, [fetchInscriptions, fetchUsers]);

    // Filter and sort inscriptions
    useEffect(() => {
        let updatedInscriptions = [...inscriptions];
        if (searchQuery) {
            updatedInscriptions = updatedInscriptions.filter(inscription =>
                (inscription.nom?.toLowerCase().includes(searchQuery.toLowerCase()) || '') ||
                (inscription.emailClient?.toLowerCase().includes(searchQuery.toLowerCase()) || '') ||
                (inscription.entreprise?.toLowerCase().includes(searchQuery.toLowerCase()) || '')
            );
        }
        if (filterHasMeeting !== 'all') {
            updatedInscriptions = updatedInscriptions.filter(inscription =>
                filterHasMeeting === 'hasMeeting' ? inscription.hasMeeting : !inscription.hasMeeting
            );
        }
        updatedInscriptions.sort((a, b) => {
            const dateA = new Date(a.dateInscription);
            const dateB = new Date(b.dateInscription);
            return sortOrder === 'desc' ? dateB - dateA : dateA - dateB;
        });
        setFilteredInscriptions(updatedInscriptions);
    }, [inscriptions, searchQuery, sortOrder, filterHasMeeting]);

    // Widgets
    const inscriptionWidgets = useMemo(() => [
        {
            title: t("inscriptions_list.widgets.total_inscriptions"),
            counter: inscriptions.length,
            suffix: '',
            decimals: 0,
            percentage: '0%',
            percentageClass: 'success',
            arrowIcon: 'ri-arrow-up-line',
            icon: 'ri-user-3-line',
        },
        {
            title: t("inscriptions_list.widgets.recent_inscriptions"),
            counter: inscriptions.filter(inscription => {
                const today = new Date('2025-07-04T11:49:00Z');
                const inscriptionDate = new Date(inscription.dateInscription);
                return (today - inscriptionDate) / (1000 * 60 * 60 * 24) <= 7;
            }).length,
            suffix: '',
            decimals: 0,
            percentage: '0%',
            percentageClass: 'success',
            arrowIcon: 'ri-arrow-up-line',
            icon: 'ri-time-line',
        },
        {
            title: t("inscriptions_list.widgets.active_inscriptions"),
            counter: inscriptions.filter(inscription => inscription.hasMeeting).length,
            suffix: '',
            decimals: 0,
            percentage: '0%',
            percentageClass: 'success',
            arrowIcon: 'ri-arrow-up-line',
            icon: 'ri-vidicon-line',
        },
    ], [inscriptions, t]);

    // Handle checkbox selection
    const handleSelect = (id) => {
        setSelectedIds(prev =>
            prev.includes(id) ? prev.filter(selectedId => selectedId !== id) : [...prev, id]
        );
    };

    const handleSelectAll = () => {
        if (selectedIds.length === filteredInscriptions.length) {
            setSelectedIds([]);
        } else {
            setSelectedIds(filteredInscriptions?.map(inscription => inscription._id));
        }
    };

    const handleDeleteInscription = async () => {
        try {
            await api.delete(`/formation/${selectedInscription._id}/cancel`, {
                withCredentials: true,
            });
            toast.success(t('inscriptions_list.success_delete'));
            setDeleteModal(false);
            fetchInscriptions();
        } catch (err) {
            if (err.response.data?.status === 401 || err.response.data?.status === 403) {
                await handleApiError(err, dispatch, navigate);
            } else {
                toast.error(t('inscriptions_list.error_delete'));
            }
        }
    };

    // Handle view
    const handleViewClick = (inscription) => {
        setSelectedInscription(inscription);
        setViewModal(true);
    };

    // Handle delete click
    const handleDeleteClick = (inscription) => {
        setSelectedInscription(inscription);
        setDeleteModal(true);
    };

    // Toggle dropdown
    const toggleDropdown = (id) => {
        setDropdownOpen(prev => ({ ...prev, [id]: !prev[id] }));
    };

    // Handle meeting form changes
    const handleMeetingFormChange = (e) => {
        const { name, value, type, checked } = e.target;
        setMeetingForm(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleDateChange = (name, date) => {
        setMeetingForm(prev => ({ ...prev, [name]: date[0] }));
    };

    // Create meeting
    const handleCreateMeeting = async () => {
        try {
            setMeetingLoading(true);
            const response = await api.post(
                '/formation/meetings',
                {
                    formationId: id,
                    title: meetingForm.title,
                    platform: meetingForm.platform,
                    date: meetingForm.date,
                    endDate: meetingForm.recurrenceType !== 'One-Time' ? meetingForm.endDate : undefined,
                    participantIds: selectedIds,
                    hostEmail: meetingForm.hostEmail,
                    requireAuthentication: meetingForm.requireAuthentication,
                    waitingRoom: meetingForm.waitingRoom,
                    recurrenceType: meetingForm.recurrenceType,
                    repeatInterval: meetingForm.repeatInterval,
                    weeklyDays: meetingForm.weeklyDays,
                    monthlyDay: meetingForm.monthlyDay,
                    password: meetingForm.password,
                    duration: meetingForm.duration,
                },
                { withCredentials: true }
            );
            const meeting = response.data.data?.meeting || response.data.meeting || response.data; // Fallback to response.data if response.data.data.meeting fails
            if (!meeting?.join_url) {
                throw new Error('Invalid response: missing join_url');
            }
            const toastContent = (
                <div>
                    {t('inscriptions_list.meeting_created')}{' '}
                    <a href={meeting.join_url} target="_blank" rel="noopener noreferrer">
                        {t('inscriptions_list.join_link')}
                    </a>
                    <Button
                        color="primary"
                        size="sm"
                        className="ms-2"
                        onClick={() =>
                            navigator.clipboard.write(meeting.join_url).then(() =>
                                toast.info(t('inscriptions_list.link_copied'), {
                                    toastId: `copy-link-${Date.now()}`,
                                })
                            )
                        }
                    >
                        {t('inscriptions_list.copy_link')}
                    </Button>
                    {meeting.emailList && meeting.emailList.length > 0 && (
                        <div className="mt-2">
                            {t('inscriptions_list.invited_emails')}:
                            <ul>
                                {meeting.emailList.map((email) => (
                                    <li key={email}>{email}</li>
                                ))}
                            </ul>
                        </div>
                    )}
                </div>
            );
            toast.success(toastContent, {
                autoClose: 5000,
                toastId: `meeting-created-${Date.now()}`,
            });
            setCreateMeetingModal(false);
            setSelectedIds([]);
            fetchInscriptions();
        } catch (err) {
            if (err.response.data?.status === 401 || err.response.data?.status === 403) {
                await handleApiError(err, dispatch, navigate);
            } else {
                toast.error(err.response?.data?.message || t('inscriptions_list.toasts.error_create_meeting'), {
                    toastId: `create-meeting-error-${Date.now()}`,
                });
            }
        } finally {
            setMeetingLoading(false);
        }
    };    // Check if inscription is from today
    const isToday = (dateInscription) => {
        const today = new Date();
        const inscriptionDate = new Date(dateInscription);
        return inscriptionDate.toLocaleDateString() === today.toLocaleDateString();
    };

    // Table columns
    const columns = useMemo(
        () => [
            {
                Header: () => (
                    <input
                        type="checkbox"
                        checked={selectedIds.length === filteredInscriptions.length && filteredInscriptions.length > 0}
                        onChange={handleSelectAll}
                    />
                ),
                accessor: '_id',
                Cell: ({ value }) => (
                    <input
                        type="checkbox"
                        checked={selectedIds.includes(value)}
                        onChange={() => handleSelect(value)}
                    />
                ),
                filterable: false,
            },
            {
                Header: t("inscriptions_list.table.name"),
                accessor: 'nom',
                filterable: true,
                Cell: ({ value }) => <span>{value || '-'}</span>,
            },
            {
                Header: t("inscriptions_list.table.email"),
                accessor: 'emailClient',
                filterable: true,
                Cell: ({ value }) => <span>{value}</span>,
            },
            {
                Header: t("inscriptions_list.table.company"),
                accessor: 'entreprise',
                filterable: true,
                Cell: ({ value }) => <span>{value || '-'}</span>,
            },
            {
                Header: t("inscriptions_list.table.inscription_date"),
                accessor: 'dateInscription',
                filterable: true,
                Cell: ({ value }) => <span>{new Date(value).toLocaleDateString()}</span>,
            },
            {
                Header: t("inscriptions_list.table.status"),
                accessor: 'hasMeeting',
                filterable: true,
                Cell: ({ value, row }) => (
                    <span>
                        <span className={`badge badge-soft-${value ? 'success' : 'info'} text-uppercase`}>
                            {value ? t("inscriptions_list.table.has_meeting") : t("inscriptions_list.table.no_meeting")}
                        </span>
                        {isToday(row.original.dateInscription) && (
                            <span className="badge badge-soft-info new-badge">{t("inscriptions_list.table.new")}</span>
                        )}
                    </span>
                ),
            },
            {
                Header: t("inscriptions_list.table.actions"),
                Cell: ({ row }) => (
                    <Dropdown
                        isOpen={dropdownOpen[row.original._id] || false}
                        toggle={() => toggleDropdown(row.original._id)}
                    >
                        <DropdownToggle tag="button" className="btn btn-soft-secondary action-btn">
                            <i className="ri-more-2-fill"></i>
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem onClick={() => handleViewClick(row.original)}>
                                <i className="ri-eye-fill me-1"></i> {t("inscriptions_list.table.view")}
                            </DropdownItem>
                            <DropdownItem onClick={() => handleDeleteClick(row.original)}>
                                <i className="ri-delete-bin-fill me-1"></i> {t("inscriptions_list.table.delete")}
                            </DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                ),
            },
        ],
        [dropdownOpen, selectedIds, t]
    );

    return (
        <React.Fragment>
            <style>{customStyles}</style>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title={`Inscriptions List `} pageTitle="Inscriptions" />
                    <ToastContainer closeButton={false} limit={1} />
                    {error && <Alert color="danger">{error}</Alert>}
                    <Row>
                        {inscriptionWidgets?.map((item, key) => (
                            <Col xxl={4} sm={6} key={key}>
                                <Card className="widget-card card-animate">
                                    <CardBody>
                                        <div className="d-flex justify-content-between">
                                            <div>
                                                <p className="fw-medium text-muted mb-0">{item.title}</p>
                                                <h2 className="mt-4 ff-secondary fw-semibold">
                                                    <span className="counter-value">
                                                        <CountUp start={0} end={item.counter} duration={3} suffix={item.suffix} decimals={item.decimals} />
                                                    </span>
                                                </h2>
                                                <p className="mb-0 text-muted">
                                                    <span className={`badge bg-light text-${item.percentageClass} mb-0`}>
                                                        <i className={`${item.arrowIcon} align-middle`}></i> {item.percentage}
                                                    </span> {t("inscriptions_list.widgets.vs_previous_month")}
                                                </p>
                                            </div>
                                            <div>
                                                <div className="avatar-sm flex-shrink-0">
                                                    <span className="avatar-title bg-soft-info text-info rounded-circle fs-4">
                                                        <i className={item.icon}></i>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                    <Row>
                        <Col lg={12}>
                            <Card className="inscriptions-card">
                                <CardHeader className="d-flex align-items-center border-0">
                                    <h5 className="card-title mb-0 flex-grow-1">{t("inscriptions_list.card_title")}</h5>
                                    <div className="flex-shrink-0">
                                        <div className="filter-container hstack gap-2">
                                            <Input
                                                type="text"
                                                placeholder={t("inscriptions_list.search_placeholder")}
                                                value={searchQuery}
                                                onChange={(e) => setSearchQuery(e.target.value)}
                                                className="form-control"
                                            />
                                            <Input
                                                type="select"
                                                className="form-select"
                                                value={sortOrder}
                                                onChange={(e) => setSortOrder(e.target.value)}
                                            >
                                                <option value="desc">{t("inscriptions_list.sort_newest")}</option>
                                                <option value="asc">{t("inscriptions_list.sort_oldest")}</option>
                                            </Input>
                                            <Input
                                                type="select"
                                                className="form-select"
                                                value={filterHasMeeting}
                                                onChange={(e) => setFilterHasMeeting(e.target.value)}
                                            >
                                                <option value="all">{t("inscriptions_list.filter_all")}</option>
                                                <option value="hasMeeting">{t("inscriptions_list.filter_has_meeting")}</option>
                                                <option value="noMeeting">{t("inscriptions_list.filter_no_meeting")}</option>
                                            </Input>
                                            <Button
                                                color="success"
                                                className="action-btn"
                                                disabled={selectedIds.length === 0}
                                                onClick={() => setCreateMeetingModal(true)}
                                            >
                                                {t("inscriptions_list.create_meeting")}
                                            </Button>
                                        </div>
                                    </div>
                                </CardHeader>
                                <CardBody>
                                    {isLoading ? (
                                        <div className="text-center py-4">
                                            <Spinner color="primary" />
                                        </div>
                                    ) : error ? (
                                        <Alert color="danger">{error}</Alert>
                                    ) : (
                                        <TableContainer
                                            columns={columns}
                                            data={filteredInscriptions}
                                            isGlobalFilter={false}
                                            customPageSize={8}
                                            className="custom-header-css"
                                            divClass="table-responsive table-card mb-1"
                                            tableClass="align-middle table-nowrap inscriptions-table"
                                            theadClass="table-light text-muted"
                                            thClass=""
                                            trClass={(row) => selectedIds.includes(row._id) ? 'selected' : ''}
                                        />
                                    )}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Modal
                        isOpen={viewModal}
                        toggle={() => setViewModal(false)}
                        centered
                        className="inscriptions-modal"
                        fade
                    >
                        <ModalHeader toggle={() => setViewModal(false)} className="p-3">
                            {t("inscriptions_list.view_modal_title")}
                        </ModalHeader>
                        <ModalBody>
                            {selectedInscription && (
                                <div>
                                    <h5 className="mb-3">{t("inscriptions_list.view_modal_info")}</h5>
                                    <p><strong>{t("inscriptions_list.view_modal_name")}:</strong> {selectedInscription.nom || '-'}</p>
                                    <p><strong>{t("inscriptions_list.view_modal_email")}:</strong> {selectedInscription.emailClient}</p>
                                    <p><strong>{t("inscriptions_list.view_modal_company")}:</strong> {selectedInscription.entreprise || '-'}</p>
                                    <p><strong>{t("inscriptions_list.view_modal_date")}:</strong> {new Date(selectedInscription.dateInscription).toLocaleDateString()}</p>
                                    <p><strong>{t("inscriptions_list.view_modal_has_meeting")}:</strong> {selectedInscription.hasMeeting ? t("inscriptions_list.yes") : t("inscriptions_list.no")}</p>
                                </div>
                            )}
                        </ModalBody>
                    </Modal>
                    <Modal
                        isOpen={createMeetingModal}
                        toggle={() => setCreateMeetingModal(false)}
                        centered
                        className="inscriptions-modal"
                        fade
                    >
                        <ModalHeader toggle={() => setCreateMeetingModal(false)} className="p-3">

                        </ModalHeader>
                        <ModalBody>
                            <Row>
                                <Col md={6} className="mb-3">
                                    <label className="form-label" id="title-tooltip">
                                        <i className="ri-information-line me-1"></i> {t("inscriptions_list.meeting_title_label")}
                                    </label>
                                    <UncontrolledTooltip placement="top" target="title-tooltip">
                                        {t("inscriptions_list.meeting_title_tooltip")}
                                    </UncontrolledTooltip>
                                    <Input
                                        type="text"
                                        name="title"
                                        value={meetingForm.title}
                                        onChange={handleMeetingFormChange}
                                        className="form-control"
                                        placeholder={t("inscriptions_list.meeting_title_placeholder")}
                                        maxLength={200}
                                        disabled={meetingLoading}
                                    />
                                </Col>
                                <Col md={6} className="mb-3">
                                    <label className="form-label" id="platform-tooltip">
                                        <i className="ri-information-line me-1"></i> {t("inscriptions_list.platform_label")}
                                    </label>
                                    <UncontrolledTooltip placement="top" target="platform-tooltip">
                                        {t("inscriptions_list.platform_tooltip")}
                                    </UncontrolledTooltip>
                                    <Input
                                        type="select"
                                        name="platform"
                                        value={meetingForm.platform}
                                        onChange={handleMeetingFormChange}
                                        className="form-select"
                                        disabled={meetingLoading}
                                    >
                                        <option value="Zoom">{t("inscriptions_list.platform_zoom")}</option>
                                        <option value="GoogleMeet" disabled>{t("inscriptions_list.platform_google_meet")}</option>
                                    </Input>
                                </Col>
                                <Col md={6} className="mb-3">
                                    <label className="form-label" id="host-tooltip">
                                        <i className="ri-information-line me-1"></i> {t("inscriptions_list.host_label")}
                                    </label>
                                    <UncontrolledTooltip placement="top" target="host-tooltip">
                                        {t("inscriptions_list.host_tooltip")}
                                    </UncontrolledTooltip>
                                    <Input
                                        type="select"
                                        name="hostEmail"
                                        value={meetingForm.hostEmail}
                                        onChange={handleMeetingFormChange}
                                        className="form-select"
                                        disabled={meetingLoading}
                                    >
                                        <option value="">{t("inscriptions_list.host_select")}</option>
                                        {users?.map(user => (
                                            <option key={user._id} value={user.email}>
                                                {user.firstname} {user.lastname}
                                            </option>
                                        ))}
                                    </Input>
                                </Col>
                                <Col md={6} className="mb-3">
                                    <label className="form-label" id="duration-tooltip">
                                        <i className="ri-time-line me-1"></i> {t("inscriptions_list.duration_label")}
                                    </label>
                                    <UncontrolledTooltip placement="top" target="duration-tooltip">
                                        {t("inscriptions_list.duration_tooltip")}
                                    </UncontrolledTooltip>
                                    <Input
                                        type="number"
                                        name="duration"
                                        value={meetingForm.duration}
                                        onChange={handleMeetingFormChange}
                                        className="form-control"
                                        placeholder={t("inscriptions_list.duration_placeholder")}
                                        min="1"
                                        disabled={meetingLoading}
                                    />
                                </Col>
                                <Col md={6} className="mb-3">
                                    <label className="form-label" id="start-date-tooltip">
                                        <i className="ri-calendar-line me-1"></i> {t("inscriptions_list.start_date_label")}
                                    </label>
                                    <UncontrolledTooltip placement="top" target="start-date-tooltip">
                                        {t("inscriptions_list.start_date_tooltip")}
                                    </UncontrolledTooltip>
                                    <Flatpickr
                                        className="form-control"
                                        options={{
                                            enableTime: true,
                                            dateFormat: "Y-m-d H:i",
                                            minDate: '2025-07-04T11:49:00Z',
                                            defaultDate: meetingForm.date,
                                        }}
                                        value={meetingForm.date}
                                        onChange={(date) => handleDateChange('date', date)}
                                        disabled={meetingLoading}
                                    />
                                </Col>
                                <Col md={6} className="mb-3">
                                    <label className="form-label" id="end-date-tooltip">
                                        <i className="ri-calendar-line me-1"></i> {t("inscriptions_list.end_date_label")}
                                    </label>
                                    <UncontrolledTooltip placement="top" target="end-date-tooltip">
                                        {t("inscriptions_list.end_date_tooltip")}
                                    </UncontrolledTooltip>
                                    <Flatpickr
                                        className="form-control"
                                        options={{
                                            enableTime: true,
                                            dateFormat: "Y-m-d H:i",
                                            minDate: meetingForm.date,
                                            defaultDate: meetingForm.endDate,
                                        }}
                                        value={meetingForm.endDate}
                                        onChange={(date) => handleDateChange('endDate', date)}
                                        disabled={meetingForm.recurrenceType === 'One-Time' || meetingLoading}
                                    />
                                </Col>
                                <Col md={6} className="mb-3">
                                    <label className="form-label" id="recurrence-tooltip">
                                        <i className="ri-repeat-line me-1"></i> {t("inscriptions_list.recurrence_label")}
                                    </label>
                                    <UncontrolledTooltip placement="top" target="recurrence-tooltip">
                                        {t("inscriptions_list.recurrence_tooltip")}
                                    </UncontrolledTooltip>
                                    <Input
                                        type="select"
                                        name="recurrenceType"
                                        value={meetingForm.recurrenceType}
                                        onChange={handleMeetingFormChange}
                                        className="form-select"
                                        disabled={meetingLoading}
                                    >
                                        <option value="One-Time">{t("inscriptions_list.recurrence_one_time")}</option>
                                        <option value="Daily">{t("inscriptions_list.recurrence_daily")}</option>
                                        <option value="Weekly">{t("inscriptions_list.recurrence_weekly")}</option>
                                        <option value="Monthly">{t("inscriptions_list.recurrence_monthly")}</option>
                                    </Input>
                                </Col>
                                {meetingForm.recurrenceType === 'Weekly' && (
                                    <Col md={6} className="mb-3">
                                        <label className="form-label" id="weekly-days-tooltip">
                                            <i className="ri-calendar-line me-1"></i> {t("inscriptions_list.weekly_days_label")}
                                        </label>
                                        <UncontrolledTooltip placement="top" target="weekly-days-tooltip">
                                            {t("inscriptions_list.weekly_days_tooltip")}
                                        </UncontrolledTooltip>
                                        <Input
                                            type="text"
                                            name="weeklyDays"
                                            value={meetingForm.weeklyDays}
                                            onChange={handleMeetingFormChange}
                                            className="form-control"
                                            placeholder={t("inscriptions_list.weekly_days_placeholder")}
                                            disabled={meetingLoading}
                                        />
                                    </Col>
                                )}
                                {meetingForm.recurrenceType === 'Monthly' && (
                                    <Col md={6} className="mb-3">
                                        <label className="form-label" id="monthly-day-tooltip">
                                            <i className="ri-calendar-line me-1"></i> {t("inscriptions_list.monthly_day_label")}
                                        </label>
                                        <UncontrolledTooltip placement="top" target="monthly-day-tooltip">
                                            {t("inscriptions_list.monthly_day_tooltip")}
                                        </UncontrolledTooltip>
                                        <Input
                                            type="number"
                                            name="monthlyDay"
                                            value={meetingForm.monthlyDay}
                                            onChange={handleMeetingFormChange}
                                            className="form-control"
                                            placeholder={t("inscriptions_list.monthly_day_placeholder")}
                                            min="1"
                                            max="31"
                                            disabled={meetingLoading}
                                        />
                                    </Col>
                                )}
                                <Col md={6} className="mb-3">
                                    <label className="form-label" id="repeat-interval-tooltip">
                                        <i className="ri-repeat-line me-1"></i> {t("inscriptions_list.repeat_interval_label")}
                                    </label>
                                    <UncontrolledTooltip placement="top" target="repeat-interval-tooltip">
                                        {t("inscriptions_list.repeat_interval_tooltip")}
                                    </UncontrolledTooltip>
                                    <Input
                                        type="number"
                                        name="repeatInterval"
                                        value={meetingForm.repeatInterval}
                                        onChange={handleMeetingFormChange}
                                        className="form-control"
                                        placeholder={t("inscriptions_list.repeat_interval_placeholder")}
                                        min="1"
                                        disabled={meetingForm.recurrenceType === 'One-Time' || meetingLoading}
                                    />
                                </Col>
                                <Col md={6} className="mb-3">
                                    <label className="form-label" id="password-tooltip">
                                        <i className="ri-lock-line me-1"></i> {t("inscriptions_list.password_label")}
                                    </label>
                                    <UncontrolledTooltip placement="top" target="password-tooltip">
                                        {t("inscriptions_list.password_tooltip")}
                                    </UncontrolledTooltip>
                                    <Input
                                        type="text"
                                        name="password"
                                        value={meetingForm.password}
                                        onChange={handleMeetingFormChange}
                                        className="form-control"
                                        placeholder={t("inscriptions_list.password_placeholder")}
                                        disabled={meetingLoading}
                                    />
                                </Col>
<Col md={6} className="mb-3">
                                  <FormGroup check>
                                    <Input
                                      type="checkbox"
                                      name="requireAuthentication"
                                      checked={meetingForm.requireAuthentication}
                                      onChange={handleMeetingFormChange}
                                      disabled={true} // Keep the checkbox disabled
                                      id="require-authentication-tooltip" // Add an ID for the tooltip target
                                    />
                                    <Label check className="form-check-label">
                                      Require Authentication
                                    </Label>
                                    <UncontrolledTooltip placement="top" target="require-authentication-tooltip">
                                      This option is disabled because authentication is mandatory for all meetings.
                                    </UncontrolledTooltip>
                                  </FormGroup>
                                </Col>
                                <Col md={6} className="mb-3">
                                    <FormGroup check>
                                        <Input
                                            type="checkbox"
                                            name="waitingRoom"
                                            checked={meetingForm.waitingRoom}
                                            onChange={handleMeetingFormChange}
                                            disabled={meetingLoading}
                                        />
                                        <Label check className="form-check-label">
                                            {t("inscriptions_list.waiting_room_label")}
                                        </Label>
                                    </FormGroup>
                                </Col>
                            </Row>
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                color="primary"
                                onClick={handleCreateMeeting}
                                disabled={meetingLoading}
                            >
                                {meetingLoading ? <Spinner size="sm" /> : t("inscriptions_list.create_button")}
                            </Button>
                            <Button
                                color="secondary"
                                onClick={() => setCreateMeetingModal(false)}
                                disabled={meetingLoading}
                            >
                                {t("inscriptions_list.cancel_button")}
                            </Button>
                        </ModalFooter>
                    </Modal>
                    <DeleteModal
                        show={deleteModal}
                        onDeleteClick={handleDeleteInscription}
                        onCloseClick={() => setDeleteModal(false)}
                    />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default InscriptionsList;